module.exports = __webpack_public_path__ + "static/media/12UNCTAD5.c3c0e8a1.jpg";